export function toggle(menu: HTMLElement): void {
  menu.classList.toggle("hidden");
}

export function close(menu: HTMLElement): void {
  menu.classList.add("hidden");
}
